import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'
import { hasAgentsAccess } from '@/utils/agents/has-agents-access'
import { hasRevenueAccess } from '@/utils/revenue/has-revenue-access'

Vue.use(VueRouter)

const modules = require.context('./modules', false, /\.routes\.js$/)
const routes = modules.keys().reduce((acc, key) => {
  const modRoutes = modules(key).default || []
  return acc.concat(modRoutes)
}, [])

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('global/CANCEL_PENDING_REQUESTS')
  if (to.meta.requireAuth) {
    if (store.state.auth.token) {
      if (to.meta.requireAccount) {
        if (store.state.auth.account.id) {
          if (to.meta.requireAgents && !hasAgentsAccess(store.state.auth.account.id)) {
            next({ name: 'AccountDashboard' })
          } else if (to.meta.requireRevenue && !hasRevenueAccess(store.state.auth.account.id)) {
            next({ name: 'PaymentListCreate' })
          } else {
            next()
          }
        } else {
          next({ path: '/account/choose' })
        }
      } else {
        next()
      }
    } else {
      next({
        path: '/auth/signin',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  // legacyTitle covers the routes the gated rollout renamed, so the browser
  // tab does not announce the experience the account is not seeing
  const title = !hasRevenueAccess(store.state.auth.account.id) && to.meta.legacyTitle
    ? to.meta.legacyTitle
    : to.meta.title

  document.title = title ? title + ' - Piriod' : 'Piriod'
  next(true)
})

export default router
